const CommonUtil = require('../utils/CommonUtil');
const g2 = require('../g2');
/**
 * @namespace
 * @description 坐标校验工具类
 * @alias G.utils.CoordUtil
 */
let CoordUtil = {};
CoordUtil = Object.assign(CoordUtil, {
    
    /**
     * 坐标是否有效
     * @method
     * @memberOf G.utils.CoordUtil.prototype
     * @param coords {Array} 坐标[x,y]
     * @param srid {Integer} 坐标系
     * @returns {Boolean}
     */
    verify(coords, srid) {
        //判断是否为数组
        if (!(CommonUtil.isArray(coords))) {
            return false;
        }
        /*
        if (!(coords[0] * coords[1])) {
            return false;
        }
        */
        //坐标值正则校验
        let isRegValid = this._verifyCoordsReg(coords);
        if (!isRegValid) { return false; }
        
        //是否在坐标系范围内校验
        let bbox = this.getBbox(srid);
        let isWithinSridBbox = this._isCoordWithinBbox(coords, bbox);
        
        return isWithinSridBbox;
    },
    /**
     * 根据坐标系获取坐标范围
     * @method
     * @memberOf G.utils.CoordUtil.prototype
     * @param srid {Integer}坐标系
     * @returns {Array}
     */
    getBbox(srid) {
        //用以坐标转换的真实坐标（规避g2转换bug）
        const realBottomLeft = [-179.999999, -89.999999];
        const realTopRight = [179.999999, 89.999999];
        //地理投影无需转换
        const displayBottomLeft = [-180, -90];
        const displayTopRight = [180, 90];
        
        let bottomLeft = this._transformFromWgs84(realBottomLeft, srid);
        if (bottomLeft.toString() == realBottomLeft.toString()) {
            bottomLeft = displayBottomLeft
        }
        let topRight = this._transformFromWgs84(realTopRight, srid);
        if (topRight.toString() == realTopRight.toString()) {
            topRight = displayTopRight
        }
        let bbox = bottomLeft.concat(topRight);
        return bbox;
    },
    /**
     * 坐标是否在中国境内（粗略）
     * @method
     * @memberOf G.utils.CoordUtil.prototype
     * @param coords {Array} 坐标[x,y]
     * @param srid {Integer} 坐标系
     * @returns {Boolean}
     */
    withinChina(coords, srid) {
        if (!(this.verify(coords, srid))) { return false; }
        let coords_wgs84 = this._transformToWgs84(coords, srid);
        let isWithin = this._isWithinChinaWgs84(coords_wgs84);
        return isWithin;
    },
    
    //转为wgs84（4326）
    _transformToWgs84(coords, srid) {
        let coordsTransformed = this._transform(coords, srid, 4326);
        return coordsTransformed;
    },
    //自wgs84（4326）转为其它
    _transformFromWgs84(coords, srid) {
        let coordsTransformed = this._transform(coords, 4326, srid);
        return coordsTransformed;
    },
    _transform(coords, srcSrid, targetSrid) {
        let _transformer = new g2.sfs.CoordinateTransform();
        let _point = new g2.sfs.Point({
            x: coords[0],
            y: coords[1]
        })
        _point.setSpatialReference(srcSrid);
        let _pointTransformed = _transformer.transform(_point, targetSrid);
        let coordsTransformed = [_pointTransformed.x, _pointTransformed.y];
        return coordsTransformed;
    },
    //中国范围判断-wgs84（4326）粗略
    _isWithinChinaWgs84(coords) {
        const include =
            [
                [79.446200, 42.889900, 96.330000, 49.220400],
                [109.687200, 39.374200, 135.000200, 54.141500],
                [73.124600, 29.529700, 124.143255, 42.889900],
                [82.968400, 26.718600, 97.035200, 29.529700],
                [97.025300, 20.414096, 124.367395, 29.529700],
                [107.975793, 17.871542, 111.744104, 20.414096],
                [108.168592, 3.231964, 119.373474, 20.541749]
            ];
        const exclude =
            [
                [101.865200, 20.098800, 106.665000, 22.284000],
                [106.452500, 20.487800, 108.051000, 21.542200],
                [109.032300, 50.325700, 119.127000, 55.817500],
                [127.456800, 49.557400, 137.022700, 55.817500],
                [131.266200, 42.569200, 137.022700, 44.892200],
                [125.178223, 34.560859, 130.209961, 39.926588],
                [128.605957, 39.429884, 132.077635, 41.804078],
                [131.879881, 41.754922, 135.703123, 44.527843],
                [131.432559, 36.949891, 139.350583, 42.455887]
            ];
        /*  const exclude =
              [
                  [20.098800, 101.865200, 22.284000, 106.665000],
                  [20.487800, 106.452500, 21.542200, 108.051000],
                  [50.325700, 109.032300, 55.817500, 119.127000],
                  [49.557400, 127.456800, 55.817500, 137.022700],
                  [42.569200, 131.266200, 44.892200, 137.022700],
                  [34.560859, 125.178223, 39.926588, 130.209961],
                  [39.487085, 128.605957, 41.804078, 132.077635],
                  [41.754922, 131.879881, 44.527843, 135.703123]
              ];*/
        for (let index = 0; index < include.length; index++) {
            const _include = include[index];
            if (this._isCoordWithinBbox(coords, _include)) {
                for (let i = 0; i < exclude.length; i++) {
                    const _exclude = exclude[i];
                    if (this._isCoordWithinBbox(coords, _exclude)) {
                        return false;
                    }
                }
                return true;
            }
        }
        return false;
        
    },
    //坐标是否在四至内
    _isCoordWithinBbox(coords, bbox) {
        let x = coords[0];
        let y = coords[1];
        let minX = bbox[0];
        let minY = bbox[1];
        let maxX = bbox[2];
        let maxY = bbox[3];
        if (x <= maxX && x >= minX && y >= minY && y <= maxY) {
            return true;
        }
        return false;
    },
    //坐标正则验证
    _verifyCoordsReg(coords) {
        //校验规则：支持正负整数、浮点数、科学计数法（例：2.322e12）
        var regFloat = /^[+-]?[\d]+([\.][\d]+)?([Ee][+-]?[\d]+)?$/;
        var result = true;
        for (let index = 0; index < coords.length; index++) {
            const element = coords[index];
            //列表中元素为字符串或数字型
            if (!(CommonUtil.isString(element)) && isNaN(element)) {
                result = false;
                break;
            }
            //正则校验
            if (!(regFloat.test(element))) {
                result = false;
                break;
            }
        }
        return result;
    },
});

module.exports = CoordUtil;